module.exports = __webpack_public_path__ + "img/Dantam Makeover 31.4341cc58.jpg";